import { Switcher } from '@shared/ui/kit';
import { useEffect, useState } from 'react';
import { FILTER_DROPDOWN_SIZES, FILTER_FIELD_MANAGER, MANAGER_FILTER_INVITING_ONLY_LABEL } from '../consts';
import styles from '../FilterDropdown/FilterDropdown.module.scss';
import { FilterItem, SearchCheckboxFilterDropdown } from '../SearchCheckboxFilterDropdown';

interface ManagerFilterDropdownProps {
  isInvitingOnly: boolean;
  selectedAllManagers: string[];
  selectedInvitingManagers: string[];
  allManagerItems: FilterItem<string>[];
  invitingManagerItems: FilterItem<string>[];
  onApply: (payload: { isInvitingOnly: boolean; allManagers: string[]; invitingNames: string[] }) => void;
  onClose: () => void;
}

export const ManagerFilterDropdown = ({
  isInvitingOnly: initialIsInvitingOnly,
  selectedAllManagers,
  selectedInvitingManagers,
  allManagerItems,
  invitingManagerItems,
  onApply,
  onClose,
}: ManagerFilterDropdownProps) => {
  const [isInvitingOnly, setIsInvitingOnly] = useState(initialIsInvitingOnly);
  const [localAllManagers, setLocalAllManagers] = useState(selectedAllManagers);
  const [localInvitingNames, setLocalInvitingNames] = useState(selectedInvitingManagers);

  useEffect(() => {
    setIsInvitingOnly(initialIsInvitingOnly);
    setLocalAllManagers(selectedAllManagers);
    setLocalInvitingNames(selectedInvitingManagers);
  }, [initialIsInvitingOnly, selectedAllManagers, selectedInvitingManagers]);

  const onReset = () => {
    setIsInvitingOnly(false);
    setLocalAllManagers([]);
    setLocalInvitingNames([]);
    onApply({ isInvitingOnly: false, allManagers: [], invitingNames: [] });
  };

  const onToggleInvitingOnly = () => {
    setIsInvitingOnly((prev) => {
      const next = !prev;
      onApply({
        isInvitingOnly: next,
        allManagers: localAllManagers,
        invitingNames: localInvitingNames,
      });
      return next;
    });
  };

  const switcher = (
    <div className={styles.filterOption}>
      <Switcher size="small" isActive={isInvitingOnly} variant="default" changeFunction={onToggleInvitingOnly} />
      <span className={styles.filterOptionText}>{MANAGER_FILTER_INVITING_ONLY_LABEL}</span>
    </div>
  );

  const sharedProps = {
    onClose,
    selectAllLabel: 'Все менеджеры',
    size: FILTER_DROPDOWN_SIZES[FILTER_FIELD_MANAGER],
    afterSearch: switcher,
    onReset,
    isResetActive: isInvitingOnly || localAllManagers.length > 0 || localInvitingNames.length > 0,
  };

  if (isInvitingOnly) {
    return (
      <SearchCheckboxFilterDropdown
        variant="compact"
        {...sharedProps}
        items={invitingManagerItems}
        selectedValues={localInvitingNames}
        onSelectedValuesChange={setLocalInvitingNames}
        onApply={(values) => onApply({ isInvitingOnly: true, allManagers: localAllManagers, invitingNames: values })}
      />
    );
  }

  return (
    <SearchCheckboxFilterDropdown
      variant="compact"
      {...sharedProps}
      items={allManagerItems}
      selectedValues={localAllManagers}
      onSelectedValuesChange={setLocalAllManagers}
      onApply={(values) => onApply({ isInvitingOnly: false, allManagers: values, invitingNames: localInvitingNames })}
    />
  );
};
